import { render } from "./MilanResults.vue?vue&type=template&id=3a1795fd"
import script from "./MilanResults.vue?vue&type=script&lang=js"
export * from "./MilanResults.vue?vue&type=script&lang=js"

import "./MilanResults.vue?vue&type=style&index=0&id=3a1795fd&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__